import type { GlobalCrawlConfigInput } from "@repo/adapter-core";
import { GlobalCrawlConfigSchema } from "@repo/adapter-core";
import { z } from "zod";

export const RealestateAdapterConfigSchema = GlobalCrawlConfigSchema.extend({
  listingType: z.enum(["buy", "rent", "sold"]).default("buy"),
  propertyTypes: z.array(z.string()).default([]),
  sortBy: z.string().optional(),
});

export type RealestateAdapterConfig = z.infer<typeof RealestateAdapterConfigSchema>;

export const REALESTATE_DEFAULT_CONFIG: GlobalCrawlConfigInput = {
  listingType: "buy",
  propertyTypes: [],
};

export function resolveRealestateConfig(
  config: GlobalCrawlConfigInput = {},
): RealestateAdapterConfig {
  const listingType =
    config.listingType && config.listingType !== "any" ? config.listingType : "buy";
  return RealestateAdapterConfigSchema.parse({
    ...REALESTATE_DEFAULT_CONFIG,
    ...config,
    listingType,
  });
}
